module.exports = __webpack_public_path__ + "static/the-papers-of-martin-luther-king-jr-volume-iv-b6880061ff5a5d5ae93fa32f77dfccad.jpg";